import { Directive, ElementRef, Input, AfterViewInit } from '@angular/core'; // <-- Cambiado a AfterViewInit
import { AbstractControl, FormControl } from '@angular/forms';

@Directive({
  selector: '[quotientToPercentage]',
  standalone: true
})
export class QuotientToPercentageDirective implements AfterViewInit { // <-- Implementa AfterViewInit
  @Input('quotientToPercentage') control!: AbstractControl | FormControl | null;

  private inputElement!: HTMLInputElement;

  constructor(private el: ElementRef) { }

  ngAfterViewInit() {
    const formControl = this.control as FormControl;
    if (!formControl) return;

    this.inputElement = this.el.nativeElement.querySelector('input');

    if (!this.inputElement) {
      console.warn("No se encontró el elemento input dentro del componente");
      return;
    }

    if (formControl.value !== null && formControl.value !== undefined) {
      this.inputElement.value = Math.round((parseFloat(formControl.value) - 1) * 100).toString();
    }

    this.inputElement.addEventListener('input', (event: Event) => {
      const target = event.target as HTMLInputElement;
      const viewValue = parseFloat(target.value.replace(',', '.'));

      if (!isNaN(viewValue)) {
        const modelValue = parseFloat(((viewValue / 100) + 1).toFixed(2));
        formControl.setValue(modelValue, { emitEvent: false, emitModelToViewChange: false });
      } else {
        formControl.setValue(null, { emitEvent: false, emitModelToViewChange: false });
      }
    });
  }
}